<nav class="ui-stepper" *ngIf="steps.length > 0" aria-label="Approval progress">
  <div
    class="ui-stepper__item"
    *ngFor="let step of steps; let last = last"
    [class.ui-stepper__item--completed]="step.state === 'completed'"
    [class.ui-stepper__item--active]="step.state === 'active'"
    [class.ui-stepper__item--rejected]="step.state === 'rejected'">
    <div class="ui-stepper__circle">
      <mat-icon *ngIf="step.state === 'completed'">check</mat-icon>
      <mat-icon *ngIf="step.state === 'active' || step.state === 'upcoming'">{{ step.icon }}</mat-icon>
      <mat-icon *ngIf="step.state === 'rejected'">close</mat-icon>
    </div>
    <span class="ui-stepper__label">{{ step.label }}</span>
    <div class="ui-stepper__connector" *ngIf="!last" [class.ui-stepper__connector--done]="step.state === 'completed'"></div>
  </div>
</nav>
